import { JSMOverlayTemplate } from "@/components/signup/layouts/product-overlay-template.tsx";
import { SignupBackgroundLayout } from "@/components/signup/layouts/signup-background-layout.tsx";
import { SiteActivation } from "@/components/signup/site-activation/site-activation.tsx";
import { ServiceCollectionLogo } from "@/components/signup/utils/logos/service-collection-logo.tsx";
import { ExperimentView } from "@/utils/experiment/experiment-view.tsx";
import { experiments } from "@/utils/experiment/manifest.ts";

import { Headings } from "../components/headings.tsx";
import { WelcomeBackText } from "../components/welcome-back-heading.tsx";
import {
    YourPlanIncludesText,
    FreeForThreeAgentsText
} from "../components/sub-heading.tsx";

const ExistingUserContent = () => {
    return (
        <>
            <Headings
                main={<WelcomeBackText />}
                sub={<FreeForThreeAgentsText />}
            />
            <SiteActivation />
        </>
    );
};

const ExistingUserContentLofi = () => {
    return (
        <>
            <Headings
                main={<WelcomeBackText />}
                sub={<YourPlanIncludesText />}
            />
            <SiteActivation />
        </>
    );
};

export const ExistingUser = () => (
    <ExperimentView
        experiment={experiments.servCoLofiBackground}
        render={(value) =>
            value ? (
                <JSMOverlayTemplate size="sm">
                    <ExistingUserContentLofi />
                </JSMOverlayTemplate>
            ) : (
                <SignupBackgroundLayout
                    ProductLogo={<ServiceCollectionLogo />}
                    theme="yellow"
                >
                    <ExistingUserContent />
                </SignupBackgroundLayout>
            )
        }
    />
);
